import { request } from './index';

export type PackageTypeType = {
  id: number;
  name: string;
  shortName: string;
  status: boolean;
};

export async function fetchPackageTypes(): Promise<PackageTypeType[]> {
  return await request(false, { url: '/packages/types' });
}
